import React, { useState, useEffect } from 'react';
import styled from "styled-components";
import CallMadeIcon from '@material-ui/icons/CallMade';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import EventIcon from '@material-ui/icons/Event';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import GitHubIcon from '@material-ui/icons/GitHub';
import YouTubeIcon from '@material-ui/icons/YouTube';

const Finals = () => {
    const [leaderboardData, setLeaderboardData] = useState({
        show: null,
        teams: []
      });
    
      useEffect(() => {
        const fetchLeaderboardData = async () => {
          try {
            const response = await fetch('https://filthy-erin-capybara.cyclic.app/leaderboard/final');
            console.log("response : ", response);
            if (!response.ok) {
              throw new Error('Failed to fetch leaderboard data');
            }
            const data = await response.json();
            setLeaderboardData(data);
            console.log(data);
          } catch (error) {
            console.error('Error fetching leaderboard data:', error);
          }
        };
    
        fetchLeaderboardData();
      }, []);
  return (
    <Container>
        <div className="page2">
            <div className="block-centered leaderboard">
            <h2>Leaderboard - [ Finals Qualifier ]</h2>
            {leaderboardData.show === "true" ? (
                <div>
                {leaderboardData.teams.map((team, index) => (
                    <div className="table" key={index}>
                    <div className="row">
                        <div className="col rank">{team.rank}</div>
                        <div className="col team">
                        <div className="team-name">
                            {team.name}
                            <div className="links">
                            <a href={team.links.github} target="_blank" rel="noopener noreferrer">
                                <GitHubIcon />
                            </a>
                            <a href={team.links.youtube} target="_blank" rel="noopener noreferrer">
                                <YouTubeIcon className="yt" />
                            </a>
                            </div>
                        </div>
                        <div className="team-info">
                            <div className="team-members">
                            [{team.members.map((member, index) => (
                                <React.Fragment key={index}>
                                {index > 0 && ', '}
                                <a href={member.github} target="_blank" rel="noopener noreferrer">
                                    {member.username}
                                </a>
                                </React.Fragment>
                            ))}]
                            </div>
                        </div>
                        </div>
                        <div className="col score">{team.score}</div>
                    </div>
                    </div>
                ))}
                </div>
            ) : (
                <h4>{leaderboardData.show === "false" ? "Coming soon, stay tuned!" : "Loading..."}</h4>
            )}
            </div>
        </div>
    </Container>
  )
}

export default Finals

const Container = styled.div`
  min-height: 100vh;
  width: 100vw;
  background-color: #22272e;


  .page2{
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 0 50px 100px 50px;

    .block-centered{
      width: 1000px;
      
      h2{
        text-align: center;
        color: white;
        font-size: 35px;
        font-weight: 500;
        margin-bottom: 30px;
      }

      .link-btn{
        padding: 10px 20px;
        background-color: #323841;
        text-decoration: none;
        font-size: 0.85rem;
        /* text-transform: uppercase; */
        letter-spacing: 0.15rem;
        font-weight: 500;
      }

      @media (max-width: 1150px) {
        width: calc(100vw - 40px);
      }
    }
    
    .about{  
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 20px;

      p{
        margin: 0 auto;
        text-align: center;
        font-size: 1rem;
        line-height: 1.75rem;
        font-weight: 200;
        color: #e1e1e1;
        width: 500px;
        margin-bottom: 40px;

        @media (max-width: 1150px) {
          width: 100%;
          padding: 20px 0;
        }
      }

      .imp-about{
        display: flex;
        width: 500px;

        align-items: center;
        margin: 10px 0;

        svg{
          font-size: 1.75rem;
        }

        .text{
          margin-left: 20px;
          font-size: 1rem;
          line-height: 1.75rem;
          font-weight: 500;
          color: #e1e1e1;
        }

        @media (max-width: 1150px) {
          width: 100%;
          margin-bottom: 10px;

          .text{
            font-weight: 200;
          }
        }
      }
      
      img{
        width: 600px;
        border-radius: 10px;
        margin-bottom: 40px;

        @media (max-width: 1150px) {
          width: 100%;
          margin-bottom: 10px;
        }
      }

    }

    .event-timeline{
      margin-top: 100px;
      width: 100vw;

      h2{
        text-align: center;
        color: white;
        font-size: 35px;
        font-weight: 500;
        margin-bottom: 30px;
      }

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .event{
        display: flex;
        align-items: center;
        margin: 50px 0;
        position: relative;

        .circle{
          height: 200px;
          width: 200px;
          background-color: #323841;
          margin: 10px 0;
          border-radius: 50%;
          z-index: 1;

          font-size: 1.25rem;
          padding: 20px;
          text-align: center;

          display: flex;
          align-items: center;
          justify-content: center;
        }

        .content{
          /* height: 160px; */
          width: 400px;
          background-color: #e5e5e5;
          border-radius: 10px;
          position: absolute;
          padding: 20px;

          h3{
            color: #333;
            font-size: 1.15rem;
            font-weight: 500;
          }

          p{
            color: #333;
            font-size: 0.9rem;
            font-weight: 300;
          }

          svg{
            font-size: 100px;
          }
        }

        .left{
         right: 250px; 
         svg{
            position: absolute;
            right: -58px;
            top: 15px;
          }
        }

        .right{
          left: 250px; 
          svg{
            position: absolute;
            left: -58px;
            top: 15px;
          }
        }

        &:hover{
          transition-duration: 250ms;
          
          .circle{
            /* background-color: orange; */
            border: 5px solid white;
            transition-duration: 250ms;
            /* color: #333; */
            cursor: pointer;
          }
        }
      }

      .vertical-line{
        height: 1000px;
        width: 1px;
        border-left: 1px dashed white;
        position: absolute;
        z-index: 0;
      }

      @media (max-width: 1150px) {
        display: none;
      }
    }

    .event-timeline-mg{
      margin-top: 100px;
      width: calc(100vw - 40px);
      position: relative;

      h2{
        text-align: center;
        color: white;
        font-size: 35px;
        font-weight: 500;
        margin-bottom: 30px;
      }

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .event{
        display: flex;
        align-items: center;
        margin: 20px 0;
        position: relative;

        .circle{
          height: 120px;
          width: 120px;
          background-color: #323841;
          margin: 10px 0;
          border-radius: 50%;
          z-index: 1;

          font-size: 0.9rem;
          padding: 20px;
          text-align: center;

          display: flex;
          align-items: center;
          justify-content: center;
          border: 5px solid transparent;

          display: none;
        }

        .content{
          /* height: 160px; */
          width: calc(100vw - 40px);
          flex: 1;
          background-color: #e5e5e5;
          border-radius: 10px;
          padding: 20px;

          display: flex;
          flex-direction: column;
          align-items: flex-start;

          h3{
            color: #333;
            font-size: 1.15rem;
            font-weight: 500;
            text-align: left;
          }

          p{
            color: #333;
            font-size: 0.9rem;
            font-weight: 300;
            text-align: left;
          }

          .date{
            color: #333;
            font-size: 0.75rem;
            font-weight: 300;
            text-align: left;
            padding: 5px 10px;
            background-color: #daceb7;
            border-radius: 100px;
            margin-left: -5px;
            margin-bottom: 10px;
          }

          svg{
            font-size: 100px;
          }
        }

        .right{
          position: relative;
          /* margin-left: 50px; */
          /* left: 250px;  */
          svg{
            display: none;
            position: absolute;
            left: -58px;
            top: 15px;
          }
        }

        &:hover{
          transition-duration: 250ms;
          
          .circle{
            /* background-color: orange; */
            border: 5px solid white;
            transition-duration: 250ms;
            /* color: #333; */
            cursor: pointer;
          }
        }
      }

      .vertical-line{
        position: absolute;
        height: 1000px;
        width: 1px;
        border-left: 1px dashed white;
        z-index: 0;
        left: 10px;
        top: 180px;

        @media (min-width: 350px) {
          height: 850px;
        }

        @media (min-width: 400px) {
          height: 700px;
        }

        @media (min-width: 500px) {
          height: 650px;
        }

        @media (min-width: 620px) {
          height: 600px;
        }

        @media (min-width: 750px) {
          height: 550px;
        }
      }

      @media (min-width: 1150px) {
        display: none;
      }
    }

    .problem-statements{
      margin-top: 100px;

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .problem-statements-container{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .problem-statement{
          width: 100%;
          background-color: #323841;
          margin: 20px 0;
          padding: 30px;

          h3{
            font-size: 1.5rem;
            font-weight: 500;
            margin-bottom: 10px;
          }

          .desc{
            font-size: 0.9rem;
            line-height: 1.5rem;
            font-weight: 200;
          }
        }
      }
    }

    .leaderboard{
      margin-top: 100px;

      .row{
        padding: 10px; 
        background-color: #323841;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;

        .rank{
          width: 60px;
          text-align: center;
          font-weight: 600;        
          /* color: #8b8b8b;   */
        }

        .team{
          flex: 1;
          margin: 0 10px;

          
          .team-name{
            font-weight: 500;
            font-size: 1.5rem;
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            
            .links{
              display: flex;
              align-items: center;

              a{
                display: flex;
                align-items: center;

                svg{
                  font-size: 1.25rem;
                  margin-left: 10px;
                }
    
                .yt{
                  font-size: 1.5rem;
                }
              }
  
            }
          }
          .team-info{
            .team-members{
              font-size: 0.85rem;
              font-weight: 500;
              /* margin: 10px 0 20px 0; */

              a{
                text-decoration: none;
                font-weight: 500;
              }
            }
          }
        }

        .score{
          width: 60px;
          text-align: center;
          /* color: #8b8b8b;   */
        }
      }

      h4{
        text-align: center;
        font-size: 1.25rem;
        font-weight: 500;

      }
    }

  @media (max-width: 1150px) {
    padding: 50px;
  }
  }
`